// Generated B layer lookup table
// Contains flattened taxonomy for Branded

export const B_LAYER_LOOKUP = {
  LUX: {
    numericCode: '001',
    name: 'Luxury',
  },
  'LUX.GUC': {
    numericCode: '001',
    name: 'Gucci',
  },
  'LUX.PRA': {
    numericCode: '002',
    name: 'Prada',
  },
  BEV: {
    numericCode: '002',
    name: 'Beverages',
  },
  'BEV.COK': {
    numericCode: '001',
    name: 'Coke',
  },
};

export const B_SUBCATEGORIES = {
  LUX: ['LUX.GUC', 'LUX.PRA'],
  BEV: ['BEV.COK'],
};
